<template>
    <v-container fluid>
     <div class="text-h6 white--text d-md-none" style="margin-top: 10px;">Selecione a data do<br />parque desejado</div>
     <div class="text-h6 black--text d-none d-md-block" style="margin-top: 10px;">Selecione a data do<br />parque desejado</div>
      <v-row v-if="vouchers.length > 0" class="text-h6 black--text d-none d-md-block" style="margin-top: 10px; margin-bottom: 10px; color: red">Você possui vouchers validados clique para receber seu voucher</v-row>
        <div class="mx-auto block" :key="idx" v-for="(voucher, idx) in vouchers">
            <a :href="'/voucher/'+voucher.voucher" style="background-color: lightgreen; padding: 10px; border-radius: 10px;">Pedido: {{voucher.id}} - {{voucher.voucher}} - R$ {{voucher.valor | fmtNumber }}</a>
        </div>
     <v-row dense class="d-md-none">
        <v-col cols="6">
          <v-card class="mx-auto card-button block" :class="{ 'primary white--text': carrinho.parque === 1 }" @click="setParque(1)">
            <v-img src="/img/farroupilha.jpg" style="height: 170px" class="mx-auto" />
            <div class="text-center">Farroupilha</div>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card class="mx-auto card-button block" :class="{ 'primary white--text': carrinho.parque === 2 }" @click="setParque(2)">
            <v-img src="/img/viamao.jpg"  style="height: 170px" class="mx-auto" />
            <div class="text-center">Viamão</div>
          </v-card>
        </v-col>
        <v-date-picker no-title v-model="date" :allowed-dates="allowedDates" class="mt-4" full-width locale="pt-br" :min="inicio" :max="fim"></v-date-picker>
        <v-btn rounded color="secondary" block class="no-text-transform" @click="avancar()">Escolher Promoção</v-btn>
      </v-row>
      <v-row class="d-none d-md-flex">
        <v-col cols="8">
          <v-card class="mx-auto card-button" :class="{ 'primary white--text': carrinho.parque === 1 }" @click="setParque(1)">
            <v-img src="/img/farroupilha.jpg" style="height: 200px;" class="mx-auto" />
            <div class="text-center" :class="{ 'primary white--text': carrinho.parque === 1 }">Farroupilha</div>
          </v-card>
          <v-spacer style="height: 10px;"></v-spacer>
          <v-card class="mx-auto card-button ma-5" :class="{ 'primary white--text': carrinho.parque === 2 }" @click="setParque(2)">
            <v-img src="/img/viamao.jpg" style="height: 200px;" class="mx-auto" />
            <div class="text-center" :class="{ 'primary white--text': carrinho.parque === 2 }">Viamão</div>
          </v-card>
        </v-col>
        <v-col>
          <v-date-picker no-title v-model="date" :allowed-dates="allowedDates" class="mt-4" full-width locale="pt-br" :min="inicio" :max="fim"></v-date-picker>
          <v-btn rounded color="secondary" block class="no-text-transform" @click="avancar()">Escolher Promoção</v-btn>
        </v-col>
      </v-row>
      <br />
      <br />
      <br />
      <br />
      <v-snackbar v-model="snackbar" top vertical timeout="2000" :color="corSnack">{{ msgSnack }}</v-snackbar>
    </v-container>
</template>
<style scoped>
.card-button {
  height: 200px !important;
}
</style>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  data: () => ({
    date: localStorage.getItem('dataVisita') | '2023-03-13',
    snackbar: false,
    corSnack: 'red',
    msgSnack: '',
    fim: '2023-03-13',
    inicio: new Date().toISOString().substr(0, 10)
  }),
  computed: {
    ...mapState(['carrinho', 'fechado', 'hoje', 'parques', 'vouchers'])
  },
  mounted: function () {
    this.consultaVouchers();
  },
  methods: {
    ...mapActions(['consultaVouchers']),
    setParque: function (parque) {
      this.$store.commit('setParque', parque)
      this.fim = this.parques[parque].fim
      this.inicio = this.parques[parque].inicio > this.hoje ? this.parques[parque].inicio : this.hoje
      this.date = localStorage.getItem('dataVisita') > this.inicio ? localStorage.getItem('dataVisita') : this.inicio
      // console.log(this.inicio, this.fim)
      this.msgSnack = 'Agora selecione o dia de sua visita, depois clique em Escolher Promoção'
      this.corSnack = 'green'
      this.snackbar = true
    },
    allowedDates: function (val) {
      switch (this.carrinho.parque) {
        case 1:
        case 2:
          return !this.fechado[this.carrinho.parque].includes(val)
        default: return false
      }
    },
    avancar: function () {
      if (this.carrinho.parque === 0) {
        this.msgSnack = 'Você deve selecionar o parque antes de avançar'
        this.corSnack = 'red'
        this.snackbar = true
        return
      }
      this.$store.commit('setData', this.date)
      if ((this.carrinho.data === '') || (this.carrinho.data === null) || (this.carrinho.data === 0)) {
        this.msgSnack = 'Você deve selecionar a data de sua visita'
        this.corSnack = 'red'
        this.snackbar = true
        return
      }
      this.$router.push('/selecione/passaporte')
    }
  }
}
</script>
